export default __webpack_public_path__ + "107d862cfeb19b9afe0d6340601cd262.svg";